/**
 * @flow
 * @relayHash 74923a281afcab5b250629a33abe4bf4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AccountContainer_user$ref = any;
export type AccountViewQueryVariables = {|
  userId: string
|};
export type AccountViewQueryResponse = {|
  +user: ?{|
    +$fragmentRefs: AccountContainer_user$ref
  |}
|};
export type AccountViewQuery = {|
  variables: AccountViewQueryVariables,
  response: AccountViewQueryResponse,
|};
*/


/*
query AccountViewQuery(
  $userId: String!
) {
  user(userId: $userId) {
    ...AccountContainer_user
    id
  }
}

fragment AccountContainer_user on User {
  id
  email
  username
  ...LogConsentDataContainer_user
}

fragment LogConsentDataContainer_user on User {
  id
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AccountViewQuery",
  "id": null,
  "text": "query AccountViewQuery(\n  $userId: String!\n) {\n  user(userId: $userId) {\n    ...AccountContainer_user\n    id\n  }\n}\n\nfragment AccountContainer_user on User {\n  id\n  email\n  username\n  ...LogConsentDataContainer_user\n}\n\nfragment LogConsentDataContainer_user on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AccountViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "AccountContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AccountViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '79a617f710f43d30bb2e1829480e9689';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Account/__generated__/AccountViewQuery.graphql.js